/* ============================================================
   Be Neo — formularios que inscrevem na Klaviyo.

   Por que chamada direta e nao o klaviyo.js / form embed: o tema nao carrega
   o onsite JS da Klaviyo (nao ha app embed dela em settings_data), e ligar o
   embed so por causa de dois campos de e-mail traria ~90 KB de script e um
   popup-builder que ninguem pediu. A Client API aceita o POST direto do
   navegador com a CHAVE PUBLICA (company_id) — a mesma que o klaviyo.js usa;
   nao e segredo.

   Todo <form data-bn-klaviyo> desta loja passa por aqui:
     data-company  chave publica da conta (RppuJ8)
     data-list     ID da lista (X75EBa = Email List · RyJv2Y = Waitlist)
     data-source   vira `custom_source` na Klaviyo — e por ele que se sabe de
                   qual formulario o contato veio
     data-product  (opcional) produto da lista de espera; vira a propriedade
                   `bn_waitlist_product` no perfil, para segmentar o aviso de
                   lancamento

   A API responde 202 sem corpo quando aceita. Qualquer outra coisa e erro —
   e o erro aparece para a pessoa: formulario que "funciona" em silencio e
   descarta o e-mail e pior que formulario quebrado.
   ============================================================ */
(function () {
  var REVISION = '2024-10-15';
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function setState(form, state, text) {
    form.setAttribute('data-state', state);
    var msg = form.querySelector('[data-bn-msg]');
    if (msg) msg.textContent = text || '';
  }

  function submit(form, ev) {
    ev.preventDefault();
    if (form.getAttribute('data-state') === 'loading') return;

    var input = form.querySelector('input[type="email"]');
    var trap = form.querySelector('input[name="bn_company_website"]');
    var email = (input && input.value || '').trim();

    // Honeypot: robo preenche o campo escondido; gente nao ve o campo.
    if (trap && trap.value) { setState(form, 'done', form.dataset.ok); return; }

    if (!EMAIL.test(email)) {
      setState(form, 'error', form.dataset.invalid || 'Please enter a valid email address.');
      if (input) input.focus();
      return;
    }

    var props = { bn_signup_page: location.pathname };
    if (form.dataset.product) props.bn_waitlist_product = form.dataset.product;

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: form.dataset.source || 'Be Neo storefront',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: props,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: form.dataset.list } } }
      }
    };

    setState(form, 'loading', '');
    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(form.dataset.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (r.status >= 200 && r.status < 300) {
          setState(form, 'done', form.dataset.ok || 'You are on the list.');
          if (input) input.value = '';
          try {
            // Evento para o pixel/Clarity, se alguem quiser medir inscricao.
            document.dispatchEvent(new CustomEvent('bn:subscribed', { detail: { source: form.dataset.source } }));
          } catch (e) {}
        } else {
          throw new Error('HTTP ' + r.status);
        }
      })
      .catch(function () {
        setState(form, 'error', form.dataset.fail || 'Something went wrong. Please try again, or email support@beneolife.com.');
      });
  }

  function bind(root) {
    (root || document).querySelectorAll('form[data-bn-klaviyo]').forEach(function (f) {
      if (f.__bn) return;
      f.__bn = true;
      f.addEventListener('submit', function (ev) { submit(f, ev); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(); });
  else bind();
  // Editor de temas re-renderiza a section: religa.
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
